import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { ref } from '../config/constants'
import { currentUser } from '../helpers/auth'
import Row from './Row'
import { Helmet } from "react-helmet";
import { PrimaryButton } from './Button'
import { connect } from 'react-redux'
import { fetchWatchlist, removeSymbolFromWatchlist } from '../reducers/watchlist'
import telescope from '../images/telescope.png'

class Watchlist extends Component {

  getWatchList = () => {
    var user = currentUser();
    var watchlist = ref.child(`users/${user.uid}/watchlist`);

    watchlist.on('value', (snapshot) => {
      var list = snapshot.val();
      console.log(list);
      if (list) {
        this.setState({
          watchlist: list
        });
      }
    });
  }

  componentWillMount = () => {
    // this.getWatchList()
    this.props.fetchWatchlist()
  }

  removeFromWatchlist = (key, symbol) => {
    this.props.removeSymbolFromWatchlist(key, symbol)
  }

  trackLinkClick = () => {
    window.analytics.track("SAMPLE_PORTFOLIO_VIEW")
  }

  downloadCSV = (csv) => {
    // CSV FILE
    const csvFile = new Blob([csv], {type: "text/csv"});

    // Download link
    let downloadLink = document.createElement("a");

    // File name
    downloadLink.download = 'Polaris Investment Plan.csv';

    // We have to create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Make sure that the link is not displayed
    downloadLink.style.display = "none";

    // Add the link to your DOM
    document.body.appendChild(downloadLink);

    downloadLink.click();
  }

  toCSV = () => {
    window.analytics.track("WATCHLIST_CSV_EXPORT")

    let csv = [];
  	let rows = document.querySelectorAll("table tr");

    for (var i = 0; i < rows.length; i++) {
      let row = [];
      let cols = rows[i].querySelectorAll("td, th");

      for (let j = 0; j < cols.length; j++) {
        // If column is "Close", skip
        if  (j !== 9) {

          // Remove commas from company name
          if (j === 1) {
            let companyName = cols[j].innerText
            companyName = companyName.replace(/,/g , "");
            console.log(companyName);
            row.push(companyName);
          } else {
            row.push(cols[j].innerText);
          }
        }
      }

      csv.push(row.join(","));
  	}

    csv = csv.join("\n")
    this.downloadCSV(csv)
  }

  render() {
    const { list, loading }  = this.props.watchlist;

    if (loading) {
      return (null)
    }

    const symbols = Object.keys(list).map((key, value) => {
      let data = list[key]
      var symbol = list[key].symbol

      return (

        <Row
          remove={() => this.removeFromWatchlist(key, symbol)}
          key={key}
          id={key}
          data={data}
          symbol={symbol}>
          {symbol}
        </Row>)
    });

    return(
      <div className="pa3 mw9 center">
        <Helmet>
          <title>Investment Plans</title>
        </Helmet>
        <div className="mb3 flex-ns items-end-ns justify-between-ns">
          <h2 className="fw4 mb1 item-start-ns mb0-ns">
            Investment Plans

            <a className="blue f5 ml3 link pointer" onClick={() => this.toCSV()}>Export to CSV</a>
          </h2>
          <p className="gray mt1 mb0-ns">
            <span role="img" aria-label="star">✨</span>Check out the FREE<Link onClick={() => this.trackLinkClick()} to="https://www.dropbox.com/sh/wiguecridixzsz5/AADib8HQ1qD5PgxEJmlsSkJva?dl=0" target="_blank" className="blue f5 ml3 link pointer">Portfolio Return App</Link>
          </p>
          </div>
          <div>
          <p className="gray f6 mt1 mb0-ns">
          Notes: Polaris users typically have 10 to 15 stocks in their portfolio.&nbsp;&nbsp; 
          Consider using Limit or Stop orders to automate plans. &nbsp;&nbsp;If selling, first consider replacing with a new plan.
          </p>
        </div>
        <div className="br2 shadow-custom bg-white">
          {Object.keys(list).length === 0 ? (
            <div className="tc pv5 pv6-ns ph4">
              <img src={telescope} alt='telescope' style={{width: '200px', height: 'auto'}} />
              <h3 className="f4 fw4">Keep an eye on stocks by adding them to your Investment Plans</h3>
              <p className="gray mw6 center mb4">Add a stock to your Investment Plans by searching for a stock and pressing the “Add to Plan” button at the top right of the screen.</p>
              <Link to="/quote/hbi">
                <PrimaryButton>See an example stock</PrimaryButton>
              </Link>
            </div>
          ) : (
            <div className="overflow-y-hidden overflow-x-auto nowrap">
              <table ref="table" className="collapse br2 pa3 w-100">
                <thead>
                  <tr>
                    <th data-title="a" className="pa3 tl f6 v-top">Symbol</th>
                    <th data-title="a" title="Polaris designates companies as either Stable or Dynamic. The future operations of Dynamic companies are likely to be significantly different than their current operations. The numbers used to calculate their Theoretical valuation are speculative. Click on YouTube Channel for more information." className="pa3 tl f6 v-top dn dtc-l">Ops Type</th>
                    <th data-title="a" className="pa3 tl f6 v-top dn dtc-l">Date Created</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Target Return</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Start Price</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Current Price</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Status</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Sell Low</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Watch Low</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Buy Low</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Buy High</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Watch High</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Sell High</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Theoretical Valuation</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Practical Valuation</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Market Sales Growth</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Default Sales Growth</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Sales Growth</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Shares Growth</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Future PM</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Future PE</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Sales (m)</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Shares (m)</th>
                    <th data-title="a" className="pa3 tl f6 v-top">PM</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Avg PE</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Dividend</th>
                    <th data-title="a" className="pa3 tl f6 v-top">CoE</th>
                    <th data-title="a" className="pa3 tl f6 v-top">PM Growth</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Earnings Growth</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Analysts Growth</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Future r</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Future CoE</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Future Earnings Growth</th>
                    <th data-title="a" className="pa3 tl f6 v-top">Future Rf</th>
                  </tr>
                </thead>
                <tbody>
                  {symbols}
                </tbody>
              </table>
            </div>
          ) }
        </div>
      </div>
    )
  }
}

Watchlist.defaultProps = {
  watchlist: []
}

export default connect(
  (state) => ({
    watchlist: state.watchlist,
    user: state.user.currentUser,
  }),
  { fetchWatchlist, removeSymbolFromWatchlist }
)(Watchlist)



// WEBPACK FOOTER //
// ./src/components/Watchlist.js